import { combineReducers } from '@reduxjs/toolkit';
import rules from './rulesPage/root';

const root = combineReducers({ rules });

export default root;

export type StrategyState = ReturnType<typeof root>;
